import React, { Component } from 'react';
import SelectPassengers from './SelectPassengers';
import PassengersMenu from './PassengersMenu';
import { getText } from '../config';

class RoomsMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: 0,
            rooms: props.rooms,
            selectAges: false,
            selectedRoom: 0
        }

        this.plusClick = this.plusClick.bind(this);
        this.minusClick = this.minusClick.bind(this);
        this.plusClickAge = this.plusClickAge.bind(this);
        this.minusClickAge = this.minusClickAge.bind(this);
        this.addRoom = this.addRoom.bind(this);
        this.toggleRoom = this.toggleRoom.bind(this);
        this.toggleAges = this.toggleAges.bind(this);
        this.getRoomsTotal = this.getRoomsTotal.bind(this);
    }

    addRoom() {
        this.props.showErrorMsg(null);
        if(this.getRoomsTotal() >= 9) return this.props.showErrorMsg(getText('maxPassengersError'))
        let rooms = this.state.rooms;

        rooms.push({
            adult: 1,
            child: 0,
            baby: 0,
            senior: 0,
            childAges: []
        })

        this.props.saveHandler(rooms);

        this.setState({
            selected: rooms.length-1
        })
    }

    toggleAges(show, room) {
        this.props.showErrorMsg(null);
        if((show && room > -1 && this.state.rooms[room].child < 3) || !show) {
            this.setState({
                selectAges: show,
                selectedRoom: room
            })
        }
    }

    toggleRoom(id) {
        this.props.showErrorMsg(null);
        this.setState({
            selected: id
        })
    }

    plusClick(id, type) {
        this.props.showErrorMsg(null);
        if(this.getRoomsTotal() >= 9 && type !== 'baby') this.props.showErrorMsg(getText('maxPassengersError'));
        if(type === 'baby' && this.state.baby >= this.state.adult) this.props.showErrorMsg(getText('babyWithAdultError'));

        if((this.getRoomsTotal() < 9) || (type === 'baby' && this.state.rooms[id].baby < this.state.rooms[id].adult)) {
            let rooms = this.state.rooms;

            if(type === 'baby' && (rooms[id].adult === 0 || rooms[id].baby >= rooms[id].adult)) return this.props.showErrorMsg(getText('babyWithAdultError'));
            if(type === 'child' && rooms[id][type] >= 3) return this.props.showErrorMsg(getText('maxThreeChildError'));

            if ((type !== 'child' && rooms[id][type] < 6) || (type === 'child' && rooms[id][type] < 3)) {
                rooms[id][type] = rooms[id][type] + 1

                if (type === 'child') rooms[id].childAges.push(2)
            }

            this.props.saveHandler(rooms);
        }
    }

    getRoomsTotal(id) {
        if(id) return this.state.rooms[id].adult + this.state.rooms[id].child + + this.state.rooms[id].senior;

        const rooms = this.state.rooms;
        let total = 0;

        rooms.map((room) => {
            total = total + room.adult + room.child + room.senior
        })

        return total;
    }

    minusClick(id, type) {
        this.props.showErrorMsg(null);
        let rooms = this.state.rooms;

        if(rooms[id][type] > 0) {
            rooms[id][type] = rooms[id][type] - 1;

            if(type === 'adult' && rooms[id].baby > rooms[id].adult) {
                rooms[id].baby = rooms[id].adult;
                this.props.showErrorMsg(getText('babyWithAdultError'));
            }

            if(type === 'child') rooms[id].childAges.pop()
        }

        if((rooms[id].adult + rooms[id].child + + rooms[id].senior + rooms[id].baby) === 0) {
            rooms.splice(id,1);
            this.toggleRoom(rooms.length-1)
        }

        this.props.saveHandler(rooms);
    }

    plusClickAge(id, child) {
        this.props.showErrorMsg(null);
        let rooms = this.state.rooms;

        if(rooms[id].childAges[child] < 12) {
            rooms[id].childAges[child] = rooms[id].childAges[child] + 1
        }

        this.props.saveHandler(rooms);
    }

    minusClickAge(id, child) {
        this.props.showErrorMsg(null);
        let rooms = this.state.rooms;

        if(rooms[id].childAges[child] > 2) {
            rooms[id].childAges[child] = rooms[id].childAges[child] - 1
        }

        this.props.saveHandler(rooms);
    }

    render() {
        const maxRooms = this.props.isMobile ? 2 : 3
        return (
            <div className="rooms-menu">
                {this.state.rooms.map((room, id) => {
                    return (
                        !this.state.selectAges && <div className={"room-container" + (this.state.selected === id ? " open" : "")} key={"room_" + id}>
                            <div className="room-title">{getText('room') + " " + (id+1)}</div>
                            <div className="room-description" onClick={this.toggleRoom.bind(this, id)}>
                                <div className="room-summary">
                                    <span className="room-number">{getText('room') + " " + (id+1) + " -"}</span>
                                    {room.adult > 0 && <span className="room room-adult">{room.adult + " " + getText('adult')}</span>}
                                    {room.child > 0 && <span className="room room-child">{room.child + " " + getText('child')}</span>}
                                    {room.baby > 0 && <span className="room room-baby">{room.baby + " " + getText('baby')}</span>}
                                    {room.senior > 0 && <span className="room room-senior">{room.senior + " " + getText('senior')}</span>}
                                    <span className="room-total">{getText('total') + " " + (room.adult + room.child + room.baby + room.senior) + " " + getText('guests')}</span>
                                </div>
                                <div className="room-toggle" />
                            </div>
                            <PassengersMenu
                                adult={room.adult}
                                child={room.child}
                                baby={room.baby}
                                senior={room.senior}
                                selectAges={this.toggleAges}
                                childAges={!this.props.isMobile ? room.childAges : []}
                                isMobile={this.props.isMobile}
                                searchType={this.props.searchType}
                                roomId={id}
                                imgPath={this.props.imgPath}
                                plusClickAge={this.plusClickAge.bind(this, id)}
                                minusClickAge={this.minusClickAge.bind(this, id)}
                                plusClick={this.plusClick.bind(this, id)}
                                minusClick={this.minusClick.bind(this, id)} />
                        </div>
                    )
                })}
                {this.state.selectAges && <div className="select-child-ages">
                    <div className="close-menu" onClick={() => this.toggleAges(false)}>X</div>
                    <div className="select-child-box">
                        <div className="child-header">{getText('room') + " " + (this.state.selectedRoom+1) + getText('selectChildAgesTitle')}</div>
                        <div className="child-main-select">
                            <SelectPassengers
                                icon={this.props.imgPath + "child"}
                                text={getText('child')}
                                subText={getText('childSubText')}
                                value={this.props.rooms[this.state.selectedRoom].child}
                                addClick={this.plusClick.bind(null, this.state.selectedRoom, 'child')}
                                lessClick={this.minusClick.bind(null, this.state.selectedRoom, 'child')}
                            />
                        </div>
                        <div className="child-content">
                            <div className="child-content-title">{getText('selectChildAges')}</div>
                            {this.props.rooms[this.state.selectedRoom].childAges.map((age, i) => {
                                return <SelectPassengers
                                    key={"age_" + i}
                                    value={age}
                                    addClick={this.plusClickAge.bind(null, this.state.selectedRoom, i)}
                                    lessClick={this.minusClickAge.bind(null, this.state.selectedRoom, i)}
                                />
                            })}
                        </div>
                    </div>
                    <button className="save-rooms save-ages" onClick={() => this.toggleAges(false)}>{getText('save')}</button>
                </div>}
                {!this.state.selectAges && <div className="rooms-buttons">
                    {this.state.rooms.length < maxRooms && <button className="add-room" onClick={this.addRoom}>{getText('addRoom')}</button>}
                    <button className={"save-rooms" + (this.state.rooms.length === maxRooms ? " full" : "")} onClick={this.props.closeHandler}>{getText('save')}</button>
                </div>}
            </div>
        );
    }
}

RoomsMenu.propTypes = {
    //myProp: PropTypes.type.isRequired
};

export default RoomsMenu;


// WEBPACK FOOTER //
// ./src/components/RoomsMenu.js